/* eslint-disable */
/** flynt-disable missing-string-validations */

export interface LayoutCellData {
  /** Size of the cell in 12 columns grid. */
  colSpan?: number;
}

const baseLayoutCellData: object = {};

export const LayoutCellData = {
  fromJSON(object: any): LayoutCellData {
    const message = { ...baseLayoutCellData } as LayoutCellData;
    message.colSpan =
      object.colSpan !== undefined && object.colSpan !== null ? Number(object.colSpan) : undefined;
    return message;
  },

  toJSON(message: LayoutCellData): unknown {
    const obj: any = {};
    message.colSpan !== undefined && (obj.colSpan = message.colSpan);
    return obj;
  },
};
